import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bytes',
})
export class BytesPipe implements PipeTransform {
  transform(value: number | string, ...args: unknown[]): unknown {
    let number: number;
    if (typeof value === 'string') {
      number = Number.parseInt(value, 10);
    } else {
      number = value;
    }
    let valueUnit = 'B';

    const kilo = 1000; // note: we need kilobytes not kibibytes (1000 vs 1024)

    if (number / kilo > 1) {
      number = Math.round(number / kilo);
      valueUnit = 'KB';
    }

    if (number / kilo > 1) {
      number = Math.round(number / kilo);
      valueUnit = 'MB';
    }

    if (number / kilo > 1) {
      number = Math.round(number / kilo);
      valueUnit = 'GB';
    }

    return number + ' ' + valueUnit;
  }
}
